module.exports = __webpack_public_path__ + "static/media/boolean_operator_and_not.ad0ff85e.svg";